import { Store } from 'store/index';

const getNumberOfAppliedFilters = (store: Store) => {
  const filterGroups = store.category.filters;

  const attributeFilters = filterGroups?.attributeFilters;
  let i = 0;
  attributeFilters?.forEach((af) => {
    af.options?.forEach((option) => {
      if (option.isSelected) {
        i += 1;
      }
    });
  });

  const tagFilters = filterGroups?.tagFilters;
  tagFilters?.forEach((af) => {
    af.options?.forEach((option) => {
      if (option.isSelected) {
        i += 1;
      }
    });
  });

  return i;
};

export default getNumberOfAppliedFilters;
